import React from 'react';
import {
  Button, Col, Modal, Row,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import validateForm from 'utils/Validator';
import Form from 'components/Form/Layout';
import { yupDocNote } from 'utils/yupFields';
import logo from 'assets/img/logo-blue-full.png';
import TextField from 'components/Form/FormTextField';
import {
  DocNoteForm,
} from 'types/DocRequest';
import { IoArrowForwardCircleOutline } from 'react-icons/io5';

type DocNoteModalProps = {
  onDismissChange: () => void
  onSubmit: ( values: DocNoteForm ) => void,
};

function DocNoteModal( {
  onSubmit, onDismissChange,
}: DocNoteModalProps ) {
  const { t } = useTranslation();
  const validate = validateForm( yupDocNote );

  return (
    <Modal
      show
      centered
      size="lg"
      onHide={onDismissChange}
      onEscapeKeyDown={onDismissChange}
      className="table-docs"
    >
      <Modal.Header closeButton className="pb-0" />
      <Modal.Body className="pt-0">
        <div className="text-center">
          <img src={logo} alt="Grupo Impar" height={40} />
        </div>
        <Row className="mt-4">
          <Col md={11} className="m-auto">
            <Form
              validate={validate}
              onSubmit={( values ) => onSubmit( values as DocNoteForm )}
              body={(
                <>
                  <h2 className="text-primary mb-2">{ t( 'admin.docs.field.note' )}</h2>

                  <TextField
                    field="nota"
                  />

                  <Row className="justify-content-end">
                    <Col xs="auto">
                      <Button
                        variant="primary"
                        type="submit"
                        size="sm"
                        className="btn--rounded text--normal text--xmd"
                      >
                        {t( 'send' )}
                        <IoArrowForwardCircleOutline size={20} className="ms-2" />
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default DocNoteModal;
